<template>
    <div>
        <!-- Footer -->
        <footer class="bg-light-dynamic py-4">
            <div class="container">
                <div class="sitemap-wrapper">
                    <div class="d-flex flex-column align-items-center align-items-lg-start">
                        <!-- Logo-->                        
                        <img v-lazy="imgObjLogoNavy" ref="logo_lq_navy" alt="logo" style="width:8rem;height:8rem;" />
                        <span v-lazy:background-image="imgObjLogoNavy"></span>
                    </div>
                    <div class="d-flex flex-column align-items-center align-items-lg-start">
                        <h5>{{ $t('siteMapCol5Row1') }}</h5>
                        <div class="social-acc-wrapper">
                            <a href="./link/linkInstagram" target="_blank">
                                <font-awesome-icon class="mr-05" size="2x" :icon="['fab', 'instagram']" />
                            </a>
                            <a href="./link/linkFacebook" target="_blank">
                                <font-awesome-icon class="mr-05" size="2x" :icon="['fab', 'facebook-square']" />
                            </a>
                            <a href="./link/linkTikTok" target="_blank">                                        
                                 <font-awesome-icon class="mr-05" size="2x" :icon="['fab', 'tiktok']" />
                            </a>
                            <a href="./link/linkTwitter" target="_blank">
                                <font-awesome-icon class="mr-05" size="2x" :icon="['fab', 'twitter']" />                                         
                            </a>
                            <a href="./link/linkLinkedIn" target="_blank">
                                <font-awesome-icon class="mr-05" size="2x" :icon="['fab', 'linkedin']" />
                            </a>
                            <a href="./link/linkYouTube" target="_blank">
                                <font-awesome-icon class="mr-05" size="2x" :icon="['fab', 'youtube']" />
                            </a>
                            <a href="./link/linkSpotify" target="_blank">
                                <font-awesome-icon class="mr-05" size="2x" :icon="['fab', 'spotify']" />
                            </a>
                            <a href="./link/linkRumble" target="_blank">
                                <img :src="rumbleLogo" alt="Rumble" class="social-img mr-05" />
                            </a>
                            <a href="./link/linkLahtube" target="_blank">
                                <img :src="lahtubeLogo" alt="Lahtube" class="social-img mr-05" />
                            </a>
                            <a onclick="window.open('./link/mailContact','_blank')" target="_blank" style="cursor:pointer;">
                                <font-awesome-icon class="mr-05" size="2x" icon="envelope" />
                            </a>
                        </div>
                    </div>
                    <div class="d-flex flex-column align-items-center align-items-lg-start">
                        <h5>{{ $t('siteMapCol2Row1') }}</h5>
                        <ul class="text-small sitemap-list">
                            <li><a class="text-muted" target="_blank" href="./link/linkAdvertise" v-t="{path: 'siteMapCol2Row7'}"></a></li>
                            <li><a class="text-muted" target="_blank" href="./link/mailSani" v-t="{path: 'siteMapCol2Row2'}"></a></li>
                            <li><a class="text-muted" target="_blank" href="./link/linkWithTeacher" v-t="{path: 'siteMapCol2Row3'}"></a></li>
                            <li><a class="text-muted" target="_blank" href="./link/linkScholarship" v-t="{path: 'siteMapCol2Row5'}"></a></li>
                            <li><a class="text-muted" target="_blank" href="./link/linkBlog" v-t="{path: 'siteMapCol2Row6'}"></a></li>
                        </ul>
                    </div>
                    <div class="d-flex flex-column align-items-center align-items-lg-start">
                        <h5>{{ $t('siteMapCol4Row1') }}</h5>
                        <ul class="text-small sitemap-list">
                            <li><a class="text-muted" target="_blank" href="./link/linkTajwidWeb" v-t="{path: 'siteMapCol4Row2'}"></a></li>
                            <li><a class="text-muted" target="_blank" href="./link/linkTafsirWeb" v-t="{path: 'siteMapCol4Row3'}"></a></li>
                            <li><a class="text-muted" target="_blank" href="./link/linkQTVWeb" v-t="{path: 'siteMapCol4Row4'}"></a></li>
                        </ul>
                    </div>
                </div> <!-- end .row -->
            </div>
        </footer>
        <footer class="bg-lq-dark-blue py-3">
            <div class="container">
                <div class="small text-center text-white">
                    {{ $t('textCopyright1') }} &copy; {{ currentYearLocalized }} Learn Quran
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import rumbleLogo from '../assets/img/products/logo-rumble.webp';
import lahtubeLogo from '../assets/img/products/logo-lahtube.webp';
export default {
    name: 'SitemapSection',
    data() {
        return {
            imgObjLogoNavy: {
                src: './assets/logos/logo_lq_navy_min_v2024.png',
                error: './assets/img/loading.gif',
                loading: './assets/img/loading.gif'
            },
            rumbleLogo,
            lahtubeLogo,
        }
    },
    mounted() {
        this.$nextTick(() => {
            // alert('sitemap section finish loaded')
            this.updateLogoBasedOnTheme();
            // Add event listener to update logo when the theme changes
            window.addEventListener('themeChanged', this.updateLogoBasedOnTheme);
            // MutationObserver to detect changes to body class
            const observer = new MutationObserver(this.updateLogoBasedOnTheme);
            observer.observe(document.body, {
                attributes: true,
                attributeFilter: ['class']
            });
        });
    },
    beforeDestroy() {
        // Remove event listener on component destroy
        window.removeEventListener('themeChanged', this.updateLogoBasedOnTheme);
    },
    computed: {
        currentYearLocalized() {
            const year = new Date().getFullYear().toString();
            // If Arabic locale active, convert Western digits to Arabic-Indic digits
            if (this.$i18n && (this.$i18n.locale || '').toUpperCase() === 'AR') {
                const arabicDigits = '٠١٢٣٤٥٦٧٨٩';
                return year.replace(/\d/g, d => arabicDigits[d]);
            }
            return year; // default (non-Arabic locales)
        }
    },
    methods: {
        updateLogoBasedOnTheme() {
            const isForceDarkMode = document.body.classList.contains('force-dark');

            this.imgObjLogoNavy.src = isForceDarkMode
                ? './assets/logos/logo_lq_white_min_v2024.png'
                : './assets/logos/logo_lq_navy_min_v2024.png';
        }
    },
}
</script>

<style scoped>
.mr-05 {
    margin-right: 0.5rem;
    transition: 0.3s;
    color: #053448;
}

.mr-05:hover {
    color: #ababab;
}

.bg-lq-dark-blue {
    background-color: #053448;
}

.social-img {
    height: 2rem; /* roughly matches font-awesome 2x height */
    width: auto;
    display: inline-block;
    transition: 0.3s;
}

.social-img:hover {
    opacity: 0.7;
}

.sitemap-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    row-gap: 1rem;
}

.social-acc-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}

/* Mobile balancing: make icons occupy equal space so rows distribute (e.g., 5 per row for 10 icons) */
@media (max-width: 991.98px) {
    .social-acc-wrapper {
        padding: 0 .5rem; /* even tighter horizontal padding */
        max-width: 100%; /* allow grid to size naturally */
        margin: 0 auto; /* center within container */
        display: grid; /* switch to grid for tighter horizontal packing */
        grid-template-columns: repeat(5, auto); /* force 5 columns (2 rows of 5) */
        justify-content: center; /* center the whole grid */
        column-gap: 0.48rem; /* slightly larger horizontal gap (~ +2%) */
        row-gap: 0.75rem; /* increase vertical gap for better tap comfort */
    }
    .social-acc-wrapper a {
        /* Reset flex-based sizing and use grid cell intrinsic size */
        display: flex;
        justify-content: center;
        align-items: center;
        flex: initial;
        margin: 0; /* rely on grid gaps */
        padding: 0.4rem; /* enlarge tap area (approx 44px with icon) */
        min-width: 44px; /* accessibility target width */
        min-height: 44px; /* accessibility target height */
    }
    /* Remove extra right margin inside each icon to bring them closer */
    .social-acc-wrapper .mr-05 { 
        margin-right: 0; 
    }
}

.sitemap-list {
    padding: 0;
    list-style: none;
    text-align: center;
}

.text-align-dynamic {
    text-align: center !important;
}

@media (min-width:992px) {
    .sitemap-wrapper {
        flex-direction: row;
        padding: 0 8rem;
    }

    .sitemap-list {
        text-align: start;
    }

    .social-acc-wrapper {
        width: 10rem;
        justify-content: flex-start;
    }

    .text-align-dynamic {
        text-align: left !important;
    }
}

.bg-light-dynamic {    
    --afterclick-bg-color: #f8f9fa !important;
    background-color: var(--afterclick-bg-color) !important;
}

body.dark .bg-light-dynamic {
  --afterclick-bg-color: #dcdcdc!important;
}

body.force-dark .bg-light-dynamic {
  --afterclick-bg-color: #dcdcdc!important;
}
</style>
